import { StyledSidebarLabel } from '@/hoc/SidebarMenu/styled-components'
import MenuFlyout from '../MenuFlyout/MenuFlyout'
import MenuItemIcon from '../MenuItemIcon/MenuItemIcon'
import type { MenuFamilyView } from '../types'
import useMenuFamily from './useMenuFamily'
import { StyledFamilyChevron, StyledMenuEntrySlot, StyledMenuFamilyButton } from '../styled-components'

interface MenuFamilyProps {
  family: MenuFamilyView
  expanded: boolean
  fill: boolean
}

const MenuFamily = ({ family, expanded, fill }: MenuFamilyProps) => {
  const { isOpen, iconProps, trigger, flyout } = useMenuFamily(family)

  return (
    <StyledMenuEntrySlot data-menu-slot $fill={fill} $expanded={expanded}>
      <StyledMenuFamilyButton
        ref={trigger.ref}
        type='button'
        id={trigger.id}
        aria-label={family.label}
        aria-haspopup='menu'
        aria-expanded={isOpen}
        aria-controls={trigger.ariaControls}
        $expanded={expanded}
        $open={isOpen}
        $selected={family.selected}
        onClick={trigger.onClick}
        onKeyDown={trigger.onKeyDown}
        onMouseEnter={trigger.onMouseEnter}
        onMouseLeave={trigger.onMouseLeave}
      >
        <MenuItemIcon icon={family.icon} iconProps={iconProps} />
        <StyledSidebarLabel hidden={!expanded}>{family.label}</StyledSidebarLabel>
        <StyledFamilyChevron $hidden={!expanded} aria-hidden='true' />
      </StyledMenuFamilyButton>
      <MenuFlyout hidden={!isOpen} family={family} flyout={flyout} iconProps={iconProps} />
    </StyledMenuEntrySlot>
  )
}

export default MenuFamily
